import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed w-full h-full z-30 inset-0 flex justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isEnabledRoute && _ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createStaticVNode("<div class=\"w-full h-full inset-0 bg-gray-700 opacity-25 absolute\" data-v-e31e7b28></div><div class=\"spinner\" data-v-e31e7b28><div class=\"bounce1\" data-v-e31e7b28></div><div class=\"bounce2\" data-v-e31e7b28></div><div class=\"bounce3\" data-v-e31e7b28></div></div>", 2)
      ]))]))
    : _createCommentVNode("", true)
}